import tw, { css } from 'twin.macro'

const styles = css`
  ${tw`mb-6`}

  .nft-table {
    ${tw`hidden`}
    ${tw`lg:block`}
    ${tw`bg-neutral`}
    ${tw`text-center`}
  }

  .nft-cards {
    ${tw`lg:hidden`}
    ${tw`grid`}
    ${tw`gap-5`}
    ${tw`sm:grid-cols-2`}
  }

  .row {
    ${tw`grid`}
    ${tw`grid-cols-10`}

    &:first-of-type {
      .values,
      .key {
        ${tw`border-t-0`}
      }
    }
  }

  .values {
    ${tw`col-span-8`}
    ${tw`grid`}
    ${tw`grid-cols-4`}
    ${tw`border-t`}
    ${tw`border-neutral-ash`}
    padding: 0 5%;
  }

  .column {
    ${tw`py-12`}
    ${tw`px-4`}
    ${tw`flex`}
    ${tw`flex-col`}
    ${tw`justify-center`}

    &.key {
      ${tw`bg-neutral-charcoal`}
      ${tw`col-span-2`}
      ${tw`border-t`}
      ${tw`border-neutral-ash`}
    }
  }

  .artwork {
    width: 13.5rem;
    height: 13.5rem;

    ${tw`mx-auto`}
    ${tw`mb-6`}
    
    ${tw`lg:mb-0`}
    ${tw`lg:w-40`}
    ${tw`lg:h-40`}

    img {
      ${tw`rounded-lg`}
      ${tw`border`}
      ${tw`border-neutral-stone`}
    }
  }

  .card {
    ${tw`bg-neutral-charcoal`}
    ${tw`text-center`}
  }

  .card-name {
    ${tw`mt-6`}
    ${tw`mb-4`}
    ${tw`text-heading-sm`}
    ${tw`font-semibold`}
  }

  .card-label {
    margin-bottom: 0;
  }

  .card-value {
    ${tw`mb-4`}
  }

  .card-cta {
    ${tw`px-4`}
    ${tw`py-6`}
    ${tw`bg-neutral`}
  }
`

export default styles
